export const formatDateTimeMS = (isoString: string): string => {
  try {
    const date = new Date(isoString);
    
    const formatter = new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false, 
    });
    
    return formatter.format(date);
  } catch (error) {
    console.error('Erro ao formatar data:', error);
    return isoString;
  }
};

export const formatTimeMS = (isoString: string): string => {
  try {
    const date = new Date(isoString);
    
    const formatter = new Intl.DateTimeFormat('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
    
    return formatter.format(date);
  } catch (error) {
    return isoString;
  }
};

export const formatTimeHourMinMS = (isoString: string): string => {
  try {
    const date = new Date(isoString);
    const adjustedDate = new Date(date.getTime() - 1 * 60 * 60 * 1000);
    const hours = adjustedDate.getHours();
    const minutes = adjustedDate.getMinutes();
    
    const result = `${hours}h:${minutes.toString().padStart(2, '0')}min`;    
    return result;
  } catch (error) {
    return isoString;
  }
};